export const DOCUMENT_UPLOAD = 'file';
export const PLAID_FAQ_NOTIFICATION = 'plaidFaqNotification';
export const KISSFLOW_NOTIFICATION = 'kissflowNotification';
export const TASK_ASSIGNED_NOTIFICATION = 'taskAssigned';
export const TASK_STATUS_CHANGE_NOTIFICATION = 'taskStatusChange';
export const NEW_MESSAGE_NOTIFICATION = 'typeNewMessage';
export const EMOJI_NOTIFICATION = 'typeEmojiReaction';
export const ADDED_TO_THREAD_NOTIFICATION = 'addedToThread';
export const NEW_FEED_EMAIL_MESSAGE_NOTIFICATION = 'newFeedEmailMessage';
export const NEW_FEED_TASK_MESSAGE_NOTIFICATION = 'newFeedTaskMessage';
export const NEW_SCENARIO_COMMENT_NOTIFICATION = 'typeNewScenarioComment';

export default {
  DOCUMENT_UPLOAD,
  PLAID_FAQ_NOTIFICATION,
  KISSFLOW_NOTIFICATION,
  TASK_ASSIGNED_NOTIFICATION,
  TASK_STATUS_CHANGE_NOTIFICATION,
};
